var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kapor-form-error"},[_c('VueFeedback',{attrs:{"type":"error"},scopedSlots:_vm._u([{key:"feedback-title",fn:function(){return [_vm._v("Technikai hiba történt")]},proxy:true},{key:"feedback-action",fn:function(){return [_c('vue-button',{on:{"click":_vm.retry}},[_vm._v("Újra")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }